import { isEmpty } from 'lodash';
import React from 'react';
import { Widget } from 'src/@vymo/ui/molecules';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { getRevyreWorkflowConfig } from 'src/models/lmsConfig/queries';
import { REVYRE_HELLO_CARDS, SPG_WIDGET } from 'src/modules/constants';
import { useAppSelector } from 'src/store/hooks';
import ChildComponent from 'src/workspace/childComponent';
import {
  getHomeDashboardLeadMetrics,
  getHomeDashboardWidgetCards,
} from '../selectors';
import HelloCard from './helloCard';
import styles from './index.module.scss';

function HelloCardComponent() {
  const widgetCards = useAppSelector(getHomeDashboardWidgetCards);
  const leadMetrics = useAppSelector(getHomeDashboardLeadMetrics);
  const isSpgEnabled = getGrowthBookFeatureFlag('enable-spg');
  const revyreModules = getRevyreWorkflowConfig().filter(
    (workflow) => workflow.type !== 'HIERARCHY',
  );
  const isRevyreEnabled = !isEmpty(revyreModules) && revyreModules.length > 0;

  return (
    <>
      {isRevyreEnabled && <ChildComponent id={REVYRE_HELLO_CARDS} />}
      {isSpgEnabled &&
        widgetCards?.length > 0 &&
        widgetCards?.map((item) => (
          <ChildComponent
            key={item.code}
            id={SPG_WIDGET}
            props={{
              locationCode: 'home',
              widgetCode: item.widget_code,
            }}
          />
        ))}
      {!isRevyreEnabled && (
        <Widget
          title="Modules"
          content={
            <div className={styles.helloCard__list}>
              {leadMetrics
                ?.map((item) => {
                  if (item.type !== 'leads') return null;
                  return (
                    <HelloCard
                      name={item.name}
                      module={item.module}
                      key={`${item.module}`}
                      pages={item.pages}
                    />
                  );
                })
                ?.filter(Boolean)}
            </div>
          }
        />
      )}
    </>
  );
}

export default HelloCardComponent;
